import { render, staticRenderFns } from "./linkToLevelProviderPage.vue?vue&type=template&id=67e342cc"
import script from "./linkToLevelProviderPage.vue?vue&type=script&lang=ts"
export * from "./linkToLevelProviderPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports